import { render, staticRenderFns } from "./OrderCleaningItemAreas.vue?vue&type=template&id=fcff0662&scoped=true"
import script from "./OrderCleaningItemAreas.vue?vue&type=script&lang=js"
export * from "./OrderCleaningItemAreas.vue?vue&type=script&lang=js"
import style0 from "./OrderCleaningItemAreas.vue?vue&type=style&index=0&id=fcff0662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcff0662",
  null
  
)

export default component.exports